module.exports = __webpack_public_path__ + "static/banner-museo2-8dca0f6160f88911aed84a93641e566e.jpg";